// Is featured placement live, and how long does one use last?
// The server decides (FEATURED_PLACEMENT / FEATURED_DAYS, modules/featuredPlacement.js)
// and reports it on the public plans endpoint. Fetched once per page load.
import axios from "axios";
import { trackInteraction } from "@/utils/trackInteraction";

let configPromise = null;

/** @returns {Promise<{ enabled: boolean, days: number, priority: boolean }>} */
export function getFeaturedConfig() {
  if (!configPromise) {
    configPromise = axios
      .get("/api/subscription/plans")
      .then(({ data }) => {
        const any = Array.isArray(data) ? data[0] : null;
        return {
          enabled: !!any?.featuredPlacement,
          days: Number(any?.featuredDays) || 7,
          priority: !!any?.searchPriority, // Business ranking boost (SEARCH_PRIORITY)
        };
      })
      .catch(() => {
        configPromise = null; // let a later call retry
        return { enabled: false, days: 7, priority: false };
      });
  }
  return configPromise;
}

/** Is this ad inside its featured window? */
export function isFeaturedActive(service, now = Date.now()) {
  return !!(service?.featuredUntil && new Date(service.featuredUntil).getTime() > now);
}

// ── Exposure tracking (shown in the owner's analytics) ──────────────────────
// One impression per featured slot per result set; a WeakSet keeps a re-render
// of the same list from counting twice.
const counted = new WeakSet();

export function trackFeaturedImpressions(services) {
  for (const s of services || []) {
    if (!s || !s.featuredSlot || counted.has(s)) continue;
    counted.add(s);
    trackInteraction("featured", "impression", { label: s.servicesID });
  }
}

/** A click on an ad shown in a featured slot. */
export function trackFeaturedClick(service) {
  if (service && service.featuredSlot) {
    trackInteraction("featured", "click", { label: service.servicesID });
  }
}
